import { useParams } from 'react-router-dom';
import { Card, Container } from 'reactstrap';
import { StudentLoader } from './Loaders/StudentLoader';
import { StudentObservationFormLoader } from './Loaders/StudentObservationFormLoader';
import { StudentObservationFiltersLoader } from './Loaders/StudentObservationFiltersLoader';
import { StudentObservationsLoader } from './Loaders/StudentObservationsLoader';
import StudentObservations from './parts/StudentObservations';

export function ContainerStudentObservations() {
  const { studentId } = useParams<{ studentId: string }>();

  return (
    <Container fluid>
      <Card>
        <StudentObservationFiltersLoader fetchImmediately>
          <StudentObservationFormLoader fetchImmediately>
            <StudentLoader
              defaultQuery={{
                studentId,
              }}
              fetchImmediately
            >
              <StudentObservationsLoader
                defaultQuery={{
                  studentId,
                  items_per_page: 10,
                  page: 1,
                }}
                fetchImmediately
              >
                <StudentObservations />
              </StudentObservationsLoader>
            </StudentLoader>
          </StudentObservationFormLoader>
        </StudentObservationFiltersLoader>
      </Card>
    </Container>
  );
}
